import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pack-up",
  "use": "icon-pack-up-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-pack-up\">\r\n<path d=\"M176.1,109.3c5.5,5.4,14.3,5.4,19.8,0c5.5-5.4,5.5-14.3,0-19.7l-86-85.5C107.2,1.4,103.6,0,100,0c-3.6,0-7.2,1.4-9.9,4.1\r\n\tl-86,85.5c-5.5,5.4-5.5,14.3,0,19.7c5.5,5.4,14.3,5.4,19.8,0L100,33.6L176.1,109.3z M100,120.3l-76.1,75.6c-5.5,5.4-14.3,5.4-19.8,0\r\n\tc-5.5-5.4-5.5-14.3,0-19.7l86-85.5c2.7-2.7,6.3-4.1,9.9-4.1c3.6,0,7.2,1.4,9.9,4.1l86,85.5c5.5,5.4,5.5,14.3,0,19.7\r\n\tc-5.5,5.4-14.3,5.4-19.8,0L100,120.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pack-up.svg
// module id = bNoE
// module chunks = 13